import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useTranslation } from "react-i18next";

const IOSInstructions = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className="relative w-full pb-[56.25%] overflow-hidden">
                <iframe
                    className="absolute top-0 left-0 w-full h-full"
                    src="https://www.youtube-nocookie.com/embed/LeybtBHg0-M"
                    title="Get started with cloud gaming on Gameaway"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </div>
            <div className="self-stretch flex-col justify-start items-start gap-1 flex">
                <div className="self-stretch pb-6 justify-center items-start gap-4 inline-flex">
                    <div className="w-10 h-10 p-2 bg-gray-800 rounded-full justify-center items-center flex overflow-hidden">
                        <div className="w-6 h-6 text-center text-neutral-50 text-lg font-bold leading-7">
                            1
                        </div>
                    </div>
                    <div className="grow shrink basis-0 pt-1.5 flex-col justify-start items-center gap-2 inline-flex">
                        <div className="self-stretch text-neutral-50 text-xl font-semibold leading-7">
                            Download Moonlight
                        </div>
                        <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                            <div className="self-stretch text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                {t("instruction_moonlight")}
                            </div>
                            <div className="self-stretch text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                Download Moonlight for iOS:
                            </div>
                            <div className="self-stretch justify-start items-start gap-2 flex flex-col lg:flex-row">
                                <div className="bg-white/0 rounded-full justify-center items-center gap-2 flex">
                                    <div className="text-neutral-50 text-base font-semibold leading-normal">
                                        <a
                                            rel="noreferrer"
                                            target="_blank"
                                            href="https://apps.apple.com/us/app/moonlight-game-streaming/id1000551566"
                                        >
                                            iOS
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="self-stretch">
                                <span className="text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                    Or visit{" "}
                                </span>
                                <span className="text-neutral-50 text-base font-semibold leading-normal">
                                    <a
                                        rel="noreferrer"
                                        target="_blank"
                                        href="https://moonlight-stream.org/#"
                                    >
                                        Moonlight
                                    </a>
                                </span>
                                <span className="text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                    {" "}
                                    for more download options.
                                </span>
                            </div>
                            <div className="self-stretch">
                                <Popover modal="true">
                                    <PopoverTrigger>
                                        <span className="text-neutral-50 font-normal leading-normal decoration-dotted underline cursor-help">
                                            Moonlight Setup Tips
                                        </span>
                                    </PopoverTrigger>
                                    <PopoverContent className="border-secondary">
                                        <div>
                                            <iframe
                                                className="w-full h-full"
                                                src="https://www.youtube-nocookie.com/embed/gO1sObaRA5A"
                                                title="Get started with cloud gaming on Gameaway"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    </PopoverContent>
                                </Popover>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="self-stretch pb-6 justify-center items-start gap-4 inline-flex">
                    <div className="w-10 h-10 p-2 bg-gray-800 rounded-full justify-center items-center flex overflow-hidden">
                        <div className="w-6 h-6 text-center text-neutral-50 text-lg font-bold leading-7">
                            2
                        </div>
                    </div>
                    <div className="grow shrink basis-0 pt-1.5 flex-col justify-start items-center gap-2 inline-flex">
                        <div className="self-stretch text-neutral-50 text-xl font-semibold leading-7">
                            Power On
                        </div>
                        <div className="self-stretch">
                            <span className="text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                {t("instruction_power_on_1")}{" "}
                            </span>
                            <span className="text-neutral-50 text-base font-semibold leading-normal">
                                {t("instruction_power_on_2")}
                            </span>
                            <span className="text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                .
                            </span>
                        </div>
                    </div>
                </div>
                <div className="self-stretch pb-6 justify-center items-start gap-4 inline-flex">
                    <div className="w-10 h-10 p-2 bg-gray-800 rounded-full justify-center items-center flex overflow-hidden">
                        <div className="w-6 h-6 text-center text-neutral-50 text-lg font-bold leading-7">
                            3
                        </div>
                    </div>
                    <div className="grow shrink basis-0 pt-1.5 flex-col justify-start items-center gap-2 inline-flex">
                        <div className="self-stretch text-neutral-50 text-xl font-semibold leading-7">
                            Go to Moonlight
                        </div>
                        <div className="self-stretch">
                            <span className="text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                {t("instruction_go_to_moonlight_1")}{" "}
                            </span>
                            <span className="text-neutral-50 text-base font-semibold leading-normal">
                                +
                            </span>
                            <span className="text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                {" "}
                                {t("instruction_go_to_moonlight_2")}
                            </span>
                            <span className="text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                {t("instruction_go_to_moonlight_ios")}{" "}
                            </span>
                            <span className="text-neutral-50 text-base font-semibold leading-normal">
                                [::ffff:
                            </span>
                            <span className="text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                x.x.x.x
                            </span>
                            <span className="text-neutral-50 text-base font-semibold leading-normal">
                                ]
                            </span>
                        </div>
                    </div>
                </div>
                <div className="self-stretch pb-6 justify-center items-start gap-4 inline-flex">
                    <div className="w-10 h-10 p-2 bg-gray-800 rounded-full justify-center items-center flex overflow-hidden">
                        <div className="w-6 h-6 text-center text-neutral-50 text-lg font-bold leading-7">
                            4
                        </div>
                    </div>
                    <div className="grow shrink basis-0 pt-1.5 flex-col justify-start items-center gap-2 inline-flex">
                        <div className="self-stretch text-neutral-50 text-xl font-semibold leading-7">
                            Set your PIN
                        </div>
                        <div className="self-stretch">
                            <span className="text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                {t("instruction_set_pin_1")}{" "}
                            </span>
                            <span className="text-neutral-50 text-base font-semibold leading-normal">
                                Set PIN
                            </span>
                            <span className="text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                .
                            </span>
                        </div>
                    </div>
                </div>
                <div className="self-stretch pb-6 justify-center items-start gap-4 inline-flex">
                    <div className="w-10 h-10 p-2 bg-gray-800 rounded-full justify-center items-center flex overflow-hidden">
                        <div className="w-6 h-6 text-center text-neutral-50 text-lg font-bold leading-7">
                            5
                        </div>
                    </div>
                    <div className="grow shrink basis-0 pt-1.5 flex-col justify-start items-start gap-2 inline-flex">
                        <div className="self-stretch text-neutral-50 text-xl font-semibold leading-7">
                            Go back to Moonlight
                        </div>
                        <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                            <div className="self-stretch text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                {t("instruction_back_to_moonlight")}
                            </div>
                            <div className="pl-1.5 pr-2 py-2 bg-[#2f2f2f] rounded-xl justify-start items-center gap-3 inline-flex overflow-hidden">
                                <img
                                    className="w-[62px] h-[84.07px]"
                                    src="./moonlight-before.png"
                                    alt="before"
                                />
                                <img
                                    className="w-[62px] h-[84.07px]"
                                    src="./moonlight-after.png"
                                    alt="after"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="self-stretch pb-6 justify-center items-start gap-4 inline-flex">
                    <div className="w-10 h-10 p-2 bg-gray-800 rounded-full justify-center items-center flex overflow-hidden">
                        <div className="w-6 h-6 text-center text-neutral-50 text-lg font-bold leading-7">
                            6
                        </div>
                    </div>
                    <div className="grow shrink basis-0 pt-1.5 flex-col justify-start items-start gap-2 inline-flex">
                        <div className="self-stretch text-neutral-50 text-xl font-semibold leading-7">
                            Shut down
                        </div>
                        <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                            <div className="self-stretch text-[var(--muted-foreground)] text-base font-normal leading-normal">
                                {t("instruction_shut_down")}
                            </div>
                            <div className="pl-1.5 pr-2 py-2 bg-[#2f2f2f] rounded-xl justify-start items-center gap-3 inline-flex overflow-hidden">
                                <img
                                    className="h-[84.07px]"
                                    src="./steam-cloud.png"
                                    alt="steam cloud"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default IOSInstructions;
